module.exports = __webpack_public_path__ + "img/check-swish.9bd49650.svg";